/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconChat.vue?vue&type=template&id=d60dcdf2&scoped=true"
import script from "./IconChat.vue?vue&type=script&lang=js"
export * from "./IconChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60dcdf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60dcdf2')) {
      api.createRecord('d60dcdf2', component.options)
    } else {
      api.reload('d60dcdf2', component.options)
    }
    module.hot.accept("./IconChat.vue?vue&type=template&id=d60dcdf2&scoped=true", function () {
      api.rerender('d60dcdf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconChat.vue"
export default component.exports